import React from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
function NotAccess() {
  const globalState = useGlobalState();
  const [dataArray, setDataArray] = useState([]);
  const [isAnimation, setIsAnimation] = useState(false);
  useEffect(() => {}, []);

  function getUserLoggedOut() {
    let object = {} as any;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/GetUserLoggedOut", object)
      .then((response) => {
        if (response.data.Status === 1) {
          window.location.href = "/login";
          setIsAnimation(true);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(true);
      });
  }

  const LogOutUser = () => {
    AppContext.SetCookie("Token", "", 0);
    AppContext.SetCookie("RefreshToken", "", 0);
    globalState.setLogInUserName("");
    globalState.setLogInUserImage("");
    globalState.setLogInUserRole("");
    AppContext.LogInUserName = "";
    window.location.href = "/login";
  };

  return (
    <div>
      {isAnimation && <LoadingAnimation />}
      <div className="inline-block-d width-100 text-center page-404">
        {/* <h1>404</h1> */}
        <span>You do not have access.</span>
        <div className="flex-dj">
          <a
            className="flex-daj btn-secondary"
            onClick={() => getUserLoggedOut()}
          >
            Log Out
          </a>
        </div>
      </div>
    </div>
  );
}

export default NotAccess;
